(function (angular, app) {
    'use strict';

    app.config(['$stateProvider', 'ROUTE_ACCESS', function ($stateProvider, ROUTE_ACCESS) {
        $stateProvider.state('app.userEdit.accountInfo', {
            url: '',
            data: {
                routeAccess: ROUTE_ACCESS.LOGIN
            },
            metaTags: {
                title: ['$filter', function ($filter) {
                    return ($filter('translate')('Account Info'));
                }]
            },
            views: {
                'tab': {
                    templateUrl: 'template/views/user-edit/account-info/index.html',
                    controller: 'AccountInfoCtrl',
                    controllerAs: 'accountInfoCtrl',
                    resolve: {
                        zipCodeLimitLength:['Config', function (config) {
                            var _US_ZIP_CODE_LENGTH = 5;
                            return config.retailer.currencyCode === 'USD' ? _US_ZIP_CODE_LENGTH : undefined;
                        }],
                        AddressFormService: ['AddressFormService', function(AddressFormService) {
                            return AddressFormService.initAddressFormService();
                        }],
                    }
                }
            }
        });
    }]).controller('AccountInfoCtrl', [
        '$scope', '$q', '$filter', 'Util', 'Api', 'User', 'SeniorCitizenVerificationDialog', 'Loyalty', 'HOUSE_ENTRIES', 'CITY_TYPES', 'Config', 'LocalStorage', 'AddressFormService',
        '$rootScope', 'AddressService', 'SP_SERVICES', 'FILTER_ADDRESS_MODE', '$timeout', 'GOOGLE_MAP_ADDRESS_TYPES', 'Dialog', 'GoogleMapService', 'zipCodeLimitLength',
        function ($scope, $q, $filter, Util, Api, User, SeniorCitizenVerificationDialog, Loyalty, HOUSE_ENTRIES, CITY_TYPES, config, localStorageService, AddressFormService,
            $rootScope, AddressService, SP_SERVICES, FILTER_ADDRESS_MODE, $timeout, GOOGLE_MAP_ADDRESS_TYPES, dialog, GoogleMapService, zipCodeLimitLength
        ) {
            var accountInfoCtrl = this,
                userEditCtrl = $scope.userEditCtrl,
                translateFilter = $filter('translate');

            accountInfoCtrl.deliveryAreaMethod = config.retailer.deliveryAreaMethod
            accountInfoCtrl.isUseGMapDeliveryMethod = [SP_SERVICES.DELIVERY_AREA_METHODS.GOOGLE_MAPS, SP_SERVICES.DELIVERY_AREA_METHODS.POLYGON].includes(accountInfoCtrl.deliveryAreaMethod);
            accountInfoCtrl.isGMapWithZipCodeProvider = config.retailer.settings.autocompleteAddressField && config.retailer.settings.activeZipProvider && config.retailer.settings.activeZipProvider.name === 'Get Address';
            accountInfoCtrl.isZipCodeValid = false;
            accountInfoCtrl.dropPinDisableFields = AddressFormService.getDropPinDisableFields();
            accountInfoCtrl.isAddressVerificationEnabled = config.retailer.settings.isAddressVerificationEnabled === 'true' && accountInfoCtrl.isUseGMapDeliveryMethod;
            accountInfoCtrl.addressVerificationText = config.retailer.settings.addressVerificationText ? JSON.parse(config.retailer.settings.addressVerificationText) : {};
            accountInfoCtrl.addressVerificationTextDroppinOff = JSON.parse(config.retailer.settings.addressVerificationTextDroppinOff || '{}');
            accountInfoCtrl.formErrorCtrl = {
                city: false,
                text1: false,
                zipCode: false
            };
            accountInfoCtrl.backupAddress = {};
            accountInfoCtrl.isRunAddressAutoComplete = true;
            accountInfoCtrl.zipCodeLimitLength = zipCodeLimitLength;
            accountInfoCtrl.isUseNewAddressesFeature = AddressFormService.isUseNewAddressesFeature;

            var _ADDRESS_TYPE_MAP = {
                city: 'city',
                text1: 'address',
                zipCode: 'zipCode'

            };
            var _wasText1HouseNumberShown = false;
            var _houseNumberRegExp = new RegExp(/^[0-9 \-]+$/);
            
            accountInfoCtrl.loyaltyClubDriver = Loyalty.getRetailerClubDriver();

            User.getData(true).then(function (userData) {
                userEditCtrl.user = userData;
                userData.dateOfBirth = new Date(userData.dateOfBirth);
                
                userEditCtrl.resetUser(userData);
                _setUserPoints();

                if (userEditCtrl.user.addresses[0]) {
                    var _address = userEditCtrl.user.addresses[0];

                    AddressFormService.cleanAddressDataBaseOnRetailerConfig(_address, $rootScope.config.language.id);

                    var cloneAddress = angular.copy(_address, {});
                    angular.extend(accountInfoCtrl.backupAddress, cloneAddress);
                    accountInfoCtrl.previousFullDeliveryAddress = angular.copy({
                        address: cloneAddress,
                        externalPlaceId: cloneAddress.externalPlaceId
                    }, {});
                }

                userEditCtrl.advancedPromotionCheckbox = Util.getAdvancedPromotionCheckboxConfig(); 
                userEditCtrl.shouldShowAdvancedPromotionCheckbox = userEditCtrl.advancedPromotionCheckbox && userEditCtrl.advancedPromotionCheckbox.isActive
                onZipCodeBlur();
            });

            if ($scope.$parent.resetUser) {
                User.getData(true).then(function (userData) {
                    $scope.$parent.resetUser = false;

                    userData.dateOfBirth = new Date(userData.dateOfBirth);

                    userEditCtrl.resetUser(userData);
                });
            }

            accountInfoCtrl.save = save;
            accountInfoCtrl.getStreetAutoCompleteOptions = getStreetAutoCompleteOptions;
            accountInfoCtrl.getEntriesAutoComplete = getEntriesAutoComplete;
            accountInfoCtrl.onCityChosen = onCityChosen;
            accountInfoCtrl.isSeniorCitizenChange = isSeniorCitizenChange;
            accountInfoCtrl.checkForAutocompleteAddress = checkForAutocompleteAddress;
            accountInfoCtrl.isShowAddressField = isShowAddressField;
            accountInfoCtrl.isDropPinRequiredStreetAndHouseNumber = isDropPinRequiredStreetAndHouseNumber;
            accountInfoCtrl.isDisableAddressField = isDisableAddressField;
            accountInfoCtrl.getCityAutoCompleteOptions = getCityAutoCompleteOptions;
            accountInfoCtrl.onAutoCompleteCityChosen = onAutoCompleteCityChosen;
            accountInfoCtrl.onCityChange = onCityChange;
            accountInfoCtrl.onCityBlur = onCityBlur;
            accountInfoCtrl.onAddressChosen = onAddressChosen;
            accountInfoCtrl.onAddressChange = onAddressChange;
            accountInfoCtrl.onStreetChange = onStreetChange;
            accountInfoCtrl.onAddressInputKeyDown = onAddressInputKeyDown;
            accountInfoCtrl.getAddressAutoCompleteOptions = getAddressAutoCompleteOptions;
            accountInfoCtrl.onAddressBlur = onAddressBlur;
            accountInfoCtrl.onHouseNumberBlur = onHouseNumberBlur;
            accountInfoCtrl.onZipCodeBlur = onZipCodeBlur;
            accountInfoCtrl.saveAddress = saveAddress;
            accountInfoCtrl.saveUserInfo = saveUserInfo;
            accountInfoCtrl.cancelPinnedAddress = cancelPinnedAddress;
            accountInfoCtrl.openGoogleMapDialog = openGoogleMapDialog;
            accountInfoCtrl.editDropPinAddressField = editDropPinAddressField;
            accountInfoCtrl.onDropPinAddressFieldBlur = onDropPinAddressFieldBlur;
            accountInfoCtrl.onZipCodeChange = onZipCodeChange;
            accountInfoCtrl.getAddressFieldLabel = getAddressFieldLabel;
            accountInfoCtrl.getAddressFormFieldSettings = getAddressFormFieldSettings;
            accountInfoCtrl.getDropPinClarifyMessage = getDropPinClarifyMessage;

            accountInfoCtrl.isSeniorCitizen = userEditCtrl.user.isSeniorCitizen;
            _setDateOfBirth();
            userEditCtrl.switchTab();

            if(
                // is in pilot updates
                AddressFormService.isUseNewAddressesFeature && 
                // is GOOGLE_MAPS / POLYGON
                accountInfoCtrl.isUseGMapDeliveryMethod
            ){
                // GOOGLE_MAPS / POLYGON with Zip-code provider will use old form => don't need to load form settings
                if (accountInfoCtrl.isGMapWithZipCodeProvider) {
                    accountInfoCtrl.streetIsRequire = config.retailer.settings.addressPrecision !== DELIVERY_AREA_METHODS_PRECISION.CITY_STREET_NOT_REQUIRED;
                    return;
                }

                accountInfoCtrl.streetIsRequire = true;
                delete config.retailer.settings.enableDefaultCountry;
                
                accountInfoCtrl.isGoogleMapDropPinAllow = AddressFormService.isGoogleMapDropPinAllow;
                accountInfoCtrl.enableAddressFiltering = AddressFormService.enableAddressFiltering;
                accountInfoCtrl.isAddressFilteringCityMode = AddressFormService.isAddressFilteringCityMode;
                accountInfoCtrl.isAddressFilteringZipCodeMode = AddressFormService.isAddressFilteringZipCodeMode;
            }

            function save(event) {
                var formElement = event.target || event.srcElement || event.path[0];

                $scope.$parent.resetUser = accountInfoCtrl.form.$invalid;

                if (accountInfoCtrl.form.$invalid) {
                    return Util.setFirstErrorInput(formElement);
                } else if (userEditCtrl.user.password !== userEditCtrl.user.confirmPassword) {
                    return Util.setServerErrorToForm(accountInfoCtrl.form, formElement, {
                        response: {
                            errors: [{
                                param: 'confirmPassword',
                                msg: 'Passwords do not match'
                            }]
                        }
                    });
                }

                // can only unselect is senior citizen through here
                var isSeniorCitizen;
                if (!accountInfoCtrl.isSeniorCitizen && userEditCtrl.user.isSeniorCitizen) {
                    isSeniorCitizen = false;
                }
                

                userEditCtrl.formSubmited = true;
                if(userEditCtrl.user.phonesObj){
                    angular.forEach(userEditCtrl.user.phonesObj, function(phone){
                        if(userEditCtrl.editPhonesMode[phone.typeVal] && userEditCtrl.customPhoneValidation){
                            if(phone.customPhoneNumber && phone.customPhoneNumber !== '') {
                                phone.phoneNumber = [phone.areaCode ? phone.areaCode.toString() : '',
                                    phone.customPhoneNumber ? phone.customPhoneNumber.toString() : ''
                                ].join('');
                            }
                            else{
                                phone.phoneNumber = '';
                            }
                        }
                    })
                }
                
                if (_shouldClearAddressData()) {
                    var clearingFields = {
                        externalPlaceId: null,
                        lat: null,
                        lng: null
                    };

                    angular.extend(userEditCtrl.user.addresses[0], clearingFields);
                    angular.extend(accountInfoCtrl.backupAddress, userEditCtrl.user.addresses[0]);
                }

                var userAddress = AddressFormService.getCheckoutAddress(userEditCtrl.user.addresses[0]);
                
                return Api.request({
                    method: 'PATCH',
                    url: '/retailers/:rid/users/:uid',
                    data: {
                        general: {
                            firstName: userEditCtrl.user.firstName,
                            lastName: userEditCtrl.user.lastName,
                            birthDate: userEditCtrl.user.dateOfBirth,
                            allowSendPromotions: userEditCtrl.user.allowSendPromotions,
                            allowSendSmsPromotions: userEditCtrl.user.allowSendSmsPromotions,
                            allowSendEmailPromotions: userEditCtrl.user.allowSendEmailPromotions,
                            gender: parseFloat(userEditCtrl.user.gender),
                            orderComments: userEditCtrl.user.orderComments
                        },
                        password: userEditCtrl.user.password,
                        phones: userEditCtrl.user.phonesObj,
                        address: userAddress,
                        isSeniorCitizen: isSeniorCitizen
                    }
                }).then(function () {
                    if (isSeniorCitizen === false) {
                        userEditCtrl.user.isSeniorCitizen = isSeniorCitizen;
                    }
                    Util.checkAndRemoveErrorMessage(formElement);
                    var userPhonesActiveInputs = Object.keys(userEditCtrl.editPhonesMode);
                    if (userPhonesActiveInputs && userPhonesActiveInputs.length) {

                        userPhonesActiveInputs.forEach(function (phoneType) {
                            if(userEditCtrl.user.phonesObj && userEditCtrl.user.phonesObj[phoneType] && userEditCtrl.user.phonesObj[phoneType].phoneNumber) {
                                userEditCtrl.compileCustomValidatedPhone(userEditCtrl.user.phonesObj[phoneType])
                            }
                        })
                        userEditCtrl.setPhones();
                    }
                    return Util.showCommonDialog({
                        title: '{{\'Successful Update\' | translate}}',
                        content: '{{\'Your account info has been successfully updated\' | translate}}.'
                    });
                }).catch(function (res) {
                    Util.setServerErrorToForm(accountInfoCtrl.form, formElement, res);
                });
            }
            

            function _shouldClearAddressData() {
                var fieldsToCheck = ['city', 'text1', 'zipCode', 'street', 'houseNumber'];
                var currentAddress = userEditCtrl.user.addresses[0];
                var backupAddress = accountInfoCtrl.backupAddress;
                
                for(var i = 0; i < fieldsToCheck.length; i++) {
                    var field = fieldsToCheck[i];
                    if(backupAddress[field] === null && currentAddress[field] === null) {
                        continue;
                    }

                    if(AddressFormService.isLocationChanged(field, backupAddress, currentAddress)) {
                        return true;
                    }
                }
                
                return false;
            }

            function onCityChosen() {
                accountInfoCtrl.streetIsRequire = (userEditCtrl.citiesObject[userEditCtrl.user.addresses[0].city] && userEditCtrl.citiesObject[userEditCtrl.user.addresses[0].city].type === CITY_TYPES.MULTIPLE_ZIP_CODES);
            }

            function getStreetAutoCompleteOptions() {
                var street = userEditCtrl.user.addresses[0].street;
                if (!street) {
                    return $q.resolve();
                }

                var cityId = userEditCtrl.citiesObject[userEditCtrl.user.addresses[0].city] && userEditCtrl.citiesObject[userEditCtrl.user.addresses[0].city].id;
                if (!cityId) {
                    return $q.resolve();
                }

                return Api.request({
                    method: 'GET',
                    url: '/v2/addresses/streets',
                    params: {
                        term: street,
                        cityId: cityId,
                        size: 16
                    }
                }).then(function (data) {
                    return data.streets.map(function (street) {
                        return street.name;
                    });
                });
            }

            function getEntriesAutoComplete() {
                var result = [];
                angular.forEach(HOUSE_ENTRIES, function (entry) {
                    result.push(translateFilter(entry));
                });
                return result;
            }

            function _setDateOfBirth() {
                if (userEditCtrl.user.dateOfBirth) { // fix for input type date
                    userEditCtrl.user.dateOfBirth = new Date(userEditCtrl.user.dateOfBirth);
                }
            }

            function _setUserPoints() {
                if (!userEditCtrl.user || !accountInfoCtrl.loyaltyClubDriver) {
                    return;
                }

                accountInfoCtrl.userLoyaltyClub = Loyalty.getUserLoyaltyClub(userEditCtrl.user);
                if (!accountInfoCtrl.userLoyaltyClub) return;
                accountInfoCtrl.activeCashbackLoyalty = Loyalty.getRetailerClubConfig(accountInfoCtrl.userLoyaltyClub.loyaltyClubId);
                if (!accountInfoCtrl.activeCashbackLoyalty) return;
                if (accountInfoCtrl.activeCashbackLoyalty.pointsToCashback) {
                    accountInfoCtrl.userCashbackLoyalty = userEditCtrl.user.loyaltyClubs.length && userEditCtrl.user.loyaltyClubs.find(function (club) {
                        return club.loyaltyClubDriverId === accountInfoCtrl.loyaltyClubDriver.loyaltyClubDriverId;
                    });
                }

                if(accountInfoCtrl.userCashbackLoyalty) {
                    Util.getUserCashbackPoints(accountInfoCtrl.userCashbackLoyalty.id).then(function (response) {
                        userEditCtrl.user.points = (Number(userEditCtrl.user.points) || 0) +
                            (Number(response.points) || 0);
                    });
                }
            }

            function isSeniorCitizenChange() {
                if (!accountInfoCtrl.isSeniorCitizen || userEditCtrl.user.isSeniorCitizen) {
                    return;
                }

                return SeniorCitizenVerificationDialog.show().then(function () {
                    return User.getData();
                }).then(function (userData) {
                    userEditCtrl.resetUser(userData);
                    accountInfoCtrl.isSeniorCitizen = userData.isSeniorCitizen;
                });
            }


            function checkForAutocompleteAddress(evt) {
                Util.removeErrorsFromInputs();

                if (evt.target.disabled &&
                    config.retailer.settings.autocompleteAddressField) {
                    var formElement = angular.element(document.querySelector('.form'));
                    var serverRes = {
                        errors: [{
                            param: evt.target.name,
                            msg: 'not_editable'
                        }]
                    };
                    if(!config.retailer.settings.activeZipProvider.isLockedAddress) {
                        serverRes.errors[0].msg = 'not_editable';
                    } else if (config.retailer.settings.activeZipProvider.isLockedAddress) {
                        if (!userEditCtrl.user.addresses[0].city) {
                            serverRes.errors[0].msg = 'not_editable_locked_empty';
                        } else {
                            serverRes.errors[0].msg = 'not_editable_locked';
                        }
                    }

                    Util.setServerErrorToForm(accountInfoCtrl.form, formElement, {response: serverRes});
                }
            }

            function _extractAddressField(field) {
                return userEditCtrl.user.addresses && AddressFormService.extractAddressField(field, userEditCtrl.user.addresses[0]);
            }

            function isShowAddressField(fieldName){
                return AddressFormService.isShowAddressField(fieldName, accountInfoCtrl.isDropPinAddress, accountInfoCtrl.isDropPinAddressNotDetected);
            }

            function isDisableAddressField(filteringMode){
                return userEditCtrl.user.addresses && AddressFormService.isDisableAddressField(filteringMode, userEditCtrl.user.addresses[0]);
            }

            function isDropPinRequiredStreetAndHouseNumber(){
                return AddressFormService.isDropPinRequiredStreetAndHouseNumber(accountInfoCtrl.isDropPinAddress, accountInfoCtrl.isDropPinAddressNotDetected);
            }

            function _getInternalCities(cityQuery) {
                return AddressService.getInternalCities(cityQuery);
            }

            function _getCitiesFromGoogleMapApi(cityQuery) {
                return AddressService.getCitiesFromGoogleMapApi(cityQuery);
            }

            function getCityAutoCompleteOptions() {
                var city = _extractAddressField('city');
                if (!city) {
                    return $q.resolve([]);
                }

                //generate another promise that will return the full cities array (no only names)
                var getRequestFunc = accountInfoCtrl.isAddressVerificationEnabled ? _getCitiesFromGoogleMapApi : _getInternalCities;

                return getRequestFunc(city).then(function (data) {
                    accountInfoCtrl.suggestedCities = data.cities;
                    return data.cities;
                });
            }


            function onZipCodeChange() {
                if (!accountInfoCtrl.isAddressFilteringZipCodeMode) {
                    return;
                }
                if (accountInfoCtrl.isAddressVerificationEnabled) {
                    $scope.$emit('checkout.details.hideFormError', {
                        hiddenFields: ['zipCode'],
                    });
                    return;
                }
            }

            function onAutoCompleteCityChosen($event) {
                if (accountInfoCtrl.isAddressVerificationEnabled) {
                    var cityComponent = $event && $event.option && $event.option.component;

                    if ($event.option.placeId) {
                        cityComponent.placeId = $event.option.placeId;
                    }

                    if (cityComponent) {
                        angular.extend(userEditCtrl.user.addresses[0], cityComponent);
                        $scope.$emit('checkout.details.hideFormError', {
                            hiddenFields: ['city'],
                        });
                    }
                    onCityBlur();
                    return;
                }
            }

            function onCityChange() {
                if (accountInfoCtrl.isAddressVerificationEnabled) {
                    $scope.$emit('checkout.details.hideFormError', {
                        hiddenFields: ['city'],
                    });
                    return;
                }
            }

            function _isExistedInSuggestions(addressType, value, suggestions) {
                return AddressFormService.isExistedInSuggestions(userEditCtrl.user.addresses[0], addressType, value, suggestions);
            }

            function onCityBlur(event) {
                if(_isClickToSuggestion(event)) return;

                var _isCityChanged = _isLocationChanged('city');
                _handleOnLocationBlur('city');
                if (accountInfoCtrl.isAddressVerificationEnabled){
                    var city = _extractAddressField('city');
                    var isExisted = _isExistedInSuggestions(_ADDRESS_TYPE_MAP.city, city, accountInfoCtrl.suggestedCities);
                    if (!isExisted) {
                        $scope.$emit('checkout.details.setFormError', 'city');
                    } else {
                        $scope.$emit('checkout.details.hideFormError', {
                            hiddenFields: ['city'],
                        }); 
                    }

                    if(accountInfoCtrl.isAddressFilteringCityMode && _isCityChanged){
                        accountInfoCtrl.suggestedAddresses = [];
                        userEditCtrl.user.addresses[0].text1 = '';
                        userEditCtrl.user.addresses[0].street = '';
                        userEditCtrl.user.addresses[0].houseNumber = '';
                        userEditCtrl.user.addresses[0].zipCode = '';
                        $scope.$emit('checkout.details.hideFormError', {
                            hiddenFields: ['text1'],
                        });
                    }
                }
            }

            function _isLocationChanged(field) {
                return AddressFormService.isLocationChanged(field, accountInfoCtrl.backupAddress, userEditCtrl.user.addresses[0]);
            }

            function onAddressChosen($event, fieldName) {
                var addressComponent = $event && $event.option && $event.option.component;
                if (addressComponent) {
                    return AddressFormService.onAddressChosen(addressComponent.externalPlaceId, $rootScope.config.language.id).then(function (address) {
                        accountInfoCtrl.isRunAddressAutoComplete = false;
                        angular.extend(userEditCtrl.user.addresses[0], address);
                        angular.extend(accountInfoCtrl.backupAddress, address);
                        $scope.$emit('checkout.details.hideFormError', {
                            hiddenFields: ['city', 'text1', 'zipCode', 'street', 'houseNumber'],
                        });
                    }).finally(function () {
                        getAddressAutoCompleteOptions(fieldName, true);
                        onAddressBlur(null, fieldName);
                    });
                }
            }

            function onAddressInputKeyDown() {
                if (accountInfoCtrl.isAddressVerificationEnabled) {
                    accountInfoCtrl.isRunAddressAutoComplete = true;
                }
            }

            function _handleOnLocationBlur(emittedField) {
                AddressFormService.handleOnLocationBlur(emittedField, accountInfoCtrl.backupAddress, userEditCtrl.user.addresses[0], accountInfoCtrl.previousFullDeliveryAddress.address);
            }

            function _getZipCodeFromGoogleMapApi(zipCode) {
                return AddressService.getZipCodeFromGoogleMapApi(zipCode, '', zipCode, true);
            }

            function onZipCodeBlur() {
                if (!accountInfoCtrl.isAddressFilteringZipCodeMode) {
                    return;
                }

                var _isZipCodeChanged = _isLocationChanged('zipCode');
                _handleOnLocationBlur('zipCode');
                
                if (accountInfoCtrl.isAddressVerificationEnabled && _isZipCodeChanged) {
                    accountInfoCtrl.suggestedAddresses = [];
                    userEditCtrl.user.addresses[0].text1 = '';
                    userEditCtrl.user.addresses[0].city = '';
                    $scope.$emit('checkout.details.hideFormError', {
                        hiddenFields: ['text1'],
                    });
                }
                // run it from the accountInfoCtrl to run template overrides
                if (accountInfoCtrl.isAddressVerificationEnabled) {
                    var zipCode = _extractAddressField('zipCode');
                    if (!zipCode) {
                        return $q.resolve([]);
                    }
                    //generate another promise that will return the full cities array (no only names)
                    var zipCodesDefer = $q.defer();
                    
                    return _getZipCodeFromGoogleMapApi(zipCode).then(function (data) {
                        accountInfoCtrl.suggestedZipCodes = data.zipCodes;
                        var isExisted = _isExistedInSuggestions(_ADDRESS_TYPE_MAP.zipCode, zipCode, accountInfoCtrl.suggestedZipCodes);
                        if (!isExisted) {
                            $scope.$emit('checkout.details.setFormError', 'zipCode');
                            accountInfoCtrl.isZipCodeValid = false;
                        } else {
                            $scope.$emit('checkout.details.hideFormError', {
                                hiddenFields: ['zipCode'],
                            }); 
                            accountInfoCtrl.isZipCodeValid = !!accountInfoCtrl.suggestedZipCodes.length;
                        }
                        zipCodesDefer.resolve(data.zipCodes);
                        return data.zipCodes;
                    }).catch(function (err) {
                        zipCodesDefer.reject(err);
                    });
                }
            }

            function _setFormError(message, isNotSave) {
                // ECOM-2174: ES5 does not have default value for params, so I use negative isNotSave
                if (message && !isNotSave) {
                    accountInfoCtrl.formErrorMessage = message;
                }
                Util.setServerErrorToForm(accountInfoCtrl.addressForm, _getFormElement(), translateFilter(message));
            }

            function _getFormElement() {
                return document.getElementsByName('accountInfoCtrl.addressForm')[0];
            }


            function getAddressAutoCompleteOptions(fieldName, isForce) {
                if (!accountInfoCtrl.isRunAddressAutoComplete && !isForce) {
                    return $q.resolve([]);
                }
                
                var addressQuery = _extractAddressField(fieldName);
                var _addressFilteringMode = AddressFormService.isUseNewAddressesFeature && accountInfoCtrl.enableAddressFiltering && AddressFormService.addressFiltering ? AddressFormService.addressFiltering : null;

                return AddressService.getAddressAutoCompleteOptions(addressQuery, {
                    addressFilteringMode:  _addressFilteringMode,
                    placeId: userEditCtrl.user.addresses[0].placeId,
                    city: userEditCtrl.user.addresses[0].city,
                    zipCode: userEditCtrl.user.addresses[0].zipCode,
                    languageId: $rootScope.config.language.id
                }).then(function (addresses) {
                    accountInfoCtrl.suggestedAddresses = addresses;
                    return addresses;
                })
            }

            function onAddressChange() {
                if (accountInfoCtrl.isAddressVerificationEnabled) {
                    $scope.$emit('checkout.details.hideFormError', {
                        hiddenFields: ['text1'],
                    });
                }
            }

            function onStreetChange() {
                if (accountInfoCtrl.isAddressVerificationEnabled) {
                    $scope.$emit('checkout.details.hideFormError', {
                        hiddenFields: ['street'],
                    });
                }
            }

            function onAddressBlur(event, fieldName) {
				if (_isClickToSuggestion(event)) return;

				var validatedResult = AddressFormService.onAddressBlur(fieldName, accountInfoCtrl.backupAddress, userEditCtrl.user.addresses[0], accountInfoCtrl.suggestedAddresses);
				if (validatedResult) {
					if (!validatedResult.isValid) {
						$scope.$emit('checkout.details.setFormError', fieldName);
					} else {
						$scope.$emit('checkout.details.hideFormError', {
							hiddenFields: [fieldName]
						});

						if (validatedResult.suggestion) {
							onAddressChosen({option: validatedResult.suggestion}, fieldName);
						}
					}
				}

				_handleOnLocationBlur(fieldName);
			}

            function onHouseNumberBlur() {
                var fieldName = 'houseNumber';

                var _isAddressChanged = _isLocationChanged(fieldName);
                if(_isAddressChanged){
                    AddressFormService.cleanAddressDataBaseOnRetailerConfig(userEditCtrl.user.addresses[0]);
                }
            }

            function showText1HouseNumberWarning() {
                var _address = userEditCtrl.user.addresses[0];
                var isIgnoreValidation = [
                        _wasText1HouseNumberShown,
                        accountInfoCtrl.isGoogleMapDialogOpening,
                        !_address.text1,
                        _address.houseNumber,
                        !accountInfoCtrl.streetIsRequire,
                        _address.externalPlaceId,
                        _address.lat && _address.lng,
                    ].some(function (value) {
                        return value;
                    });

                if (isIgnoreValidation) {
                    return;
                }

                var _text1 = _address.text1;
                var splitAddress = _text1.replace(/,/g, ' ');
                splitAddress = splitAddress.replace(/\s+/g, ' ');
                splitAddress = splitAddress.split(' ');

                var hasHouseNumber = splitAddress.length >= 2 && splitAddress.some(function (word) {
                    return _houseNumberRegExp.test(word);
                });
                if (hasHouseNumber) {
                    return;
                }

                _wasText1HouseNumberShown = true;
                return Util.showCommonDialog({
                    content: '' +
                        '<strong>{{\'Please enter your house number\' | translate}}</strong>' +
                        ' <br /> ' +
                        '{{\'So we can assign you to the right branch\' | translate}}'
                });
            }

            function _verifyCityAndAddress() {
                return AddressFormService.verifyIsSuggestedValue(
                    userEditCtrl.user.addresses[0], 
                    accountInfoCtrl.isDropPinAddress, 
                    accountInfoCtrl.suggestedAddresses, 
                    accountInfoCtrl.suggestedCities, 
                    accountInfoCtrl.suggestedZipCodes
                );
            }

            function saveAddress(event) {
                var formElement = event.target || event.srcElement || event.path[0];
                if (accountInfoCtrl.addressForm.$invalid) {
                    return Util.setFirstErrorInput(formElement);
                }

                if (accountInfoCtrl.isAddressVerificationEnabled){
                    var validationResult = _verifyCityAndAddress();
                    for (var key in validationResult) {
                        if (!validationResult[key]) {
                            userEditCtrl.user.addresses[0][key] = '';
                            $scope.$emit('checkout.details.setFormError', key);
                            return;
                        }
                    }
                }
                
                var _isShowText1HouseNumberWarning = showText1HouseNumberWarning();
                if(_isShowText1HouseNumberWarning) return;

                var clonedUserAddress = angular.copy(userEditCtrl.user.addresses[0])
                if(accountInfoCtrl.isDropPinAddressNotDetected && AddressFormService.isGoogleMapDropPinValidateHouseNumAndStreet) {
                    clonedUserAddress.text1 = null;
                }
                var _userAddress = AddressFormService.getCheckoutAddress(clonedUserAddress);
                
                return Api.request({
                    method: 'PATCH',
                    url: '/retailers/:rid/users/:uid',
                    data: {
                        address: _userAddress,
                    }
                }).then(function () {
                    localStorageService.removeItem('typedAreaText');
                    localStorageService.removeItem('typedAddressText');
                    localStorageService.removeItem('newAddress');
                    localStorageService.removeItem("typedAreaAddressComponents");

                    return Util.showCommonDialog({
                        title: '{{\'Successful Update\' | translate}}',
                        content: '{{\'Your account info has been successfully updated\' | translate}}.'
                    });
                }).catch(function (res) {
                    Util.setServerErrorToForm(accountInfoCtrl.addressForm, formElement, res);
                });
            }
            
            function saveUserInfo(event) {
                var formElement = event.target || event.srcElement || event.path[0];
                if (accountInfoCtrl.userInfoForm.$invalid) {
                    return Util.setFirstErrorInput(formElement);
                } else if (userEditCtrl.user.password !== userEditCtrl.user.confirmPassword) {
                    return Util.setServerErrorToForm(accountInfoCtrl.userInfoForm, formElement, {
                        response: {
                            errors: [{
                                param: 'confirmPassword',
                                msg: 'Passwords do not match'
                            }]
                        }
                    });
                }
                // can only unselect is senior citizen through here
                var isSeniorCitizen;
                if (!accountInfoCtrl.isSeniorCitizen && userEditCtrl.user.isSeniorCitizen) {
                    isSeniorCitizen = false;
                }
                
                if(userEditCtrl.user.phonesObj){
                    angular.forEach(userEditCtrl.user.phonesObj, function(phone){
                        if(userEditCtrl.editPhonesMode[phone.typeVal] && userEditCtrl.customPhoneValidation){
                            if(phone.customPhoneNumber && phone.customPhoneNumber !== '') {
                                phone.phoneNumber = [phone.areaCode ? phone.areaCode.toString() : '',
                                    phone.customPhoneNumber ? phone.customPhoneNumber.toString() : ''
                                ].join('');
                            }
                            else{
                                phone.phoneNumber = '';
                            }
                        }
                    })
                }
                return Api.request({
                    method: 'PATCH',
                    url: '/retailers/:rid/users/:uid',
                    data: {
                        general: {
                            firstName: userEditCtrl.user.firstName,
                            lastName: userEditCtrl.user.lastName,
                            birthDate: userEditCtrl.user.dateOfBirth,
                            allowSendPromotions: userEditCtrl.user.allowSendPromotions,
                            allowSendSmsPromotions: userEditCtrl.user.allowSendSmsPromotions,
                            allowSendEmailPromotions: userEditCtrl.user.allowSendEmailPromotions,
                            gender: parseFloat(userEditCtrl.user.gender),
                            orderComments: userEditCtrl.user.orderComments
                        },
                        password: userEditCtrl.user.password,
                        phones: userEditCtrl.user.phonesObj,
                        isSeniorCitizen: isSeniorCitizen
                    }
                }).then(function () {
                    if (isSeniorCitizen === false) {
                        userEditCtrl.user.isSeniorCitizen = isSeniorCitizen;
                    }
                    Util.checkAndRemoveErrorMessage(formElement);
                    var userPhonesActiveInputs = Object.keys(userEditCtrl.editPhonesMode);
                    if (userPhonesActiveInputs && userPhonesActiveInputs.length) {
                        userPhonesActiveInputs.forEach(function (phoneType) {
                            if(userEditCtrl.user.phonesObj && userEditCtrl.user.phonesObj[phoneType] && userEditCtrl.user.phonesObj[phoneType].phoneNumber) {
                                userEditCtrl.compileCustomValidatedPhone(userEditCtrl.user.phonesObj[phoneType])
                            }
                        })
                        userEditCtrl.setPhones();
                    }
                    return Util.showCommonDialog({
                        title: '{{\'Successful Update\' | translate}}',
                        content: '{{\'Your account info has been successfully updated\' | translate}}.'
                    });
                }).catch(function (res) {
                    Util.setServerErrorToForm(accountInfoCtrl.userInfoForm, formElement, res);
                });
            }

            function cancelPinnedAddress() {
                accountInfoCtrl.isDropPinAddress = false;
                accountInfoCtrl.isDropPinAddressNotDetected = false;
                AddressFormService.cancelPinnedAddress(userEditCtrl.user.addresses[0]);
            }

            function openGoogleMapDialog() {
                accountInfoCtrl.isGoogleMapDialogOpening = true;
                var _defaultLocation = AddressFormService.getDefaultLocation(userEditCtrl.user.addresses[0]);

                dialog.show({
                    templateUrl: 'template/dialogs/google-map-dialog/index.html',
                    controller: 'GoogleMapDialogCtrl as googleMapDialogCtrl',
                    locals: {
                        defaultLocation: _defaultLocation
                    }
                }).then(function (selectedAddress) {
                    if (!selectedAddress) {
                        return;
                    }

                    _disableAllDropPinFields();
                    accountInfoCtrl.isDropPinAddress = true;
                    accountInfoCtrl.isDropPinAddressNotDetected = !selectedAddress.hasHouseNumberAndRoute;

                    var _address = AddressFormService.onDroppedPinAddress(selectedAddress);
                    angular.extend(userEditCtrl.user.addresses[0], _address);
                    angular.extend(accountInfoCtrl.backupAddress, userEditCtrl.user.addresses[0]);

                    // If users select a valid address, we will consider it as suggested address and remove validation
                    $scope.$emit('checkout.details.hideFormError', {
                        hiddenFields: ['city', 'text1', 'zipCode', 'street', 'houseNumber'],
                    });

                    if(selectedAddress.zipCode){
                        onZipCodeBlur();
                    }
                }).finally(function () {
                    $timeout(function () {
                        /**
                         * ECOM-6403: Just temporally solution for Prutah template
                         * After closing dialog, the address input is automatically focused and blurred. This behavior affects unrecognized address behavior
                         */
                        accountInfoCtrl.isGoogleMapDialogOpening = false;
                    }, 0);
                });
            }

            function editDropPinAddressField(elementSelector, field){
                var _element = document.querySelector(elementSelector);
                if (_element) {
                    accountInfoCtrl.dropPinDisableFields[field] = false;

                    $timeout(function () {
                        _element.focus();
                    }, 0);
                }
            }

            function onDropPinAddressFieldBlur(){
                _disableAllDropPinFields();
            }

            function _isClickToSuggestion(event){
                // if click to choose suggestion, disable blur event temporarily
                var _parentTargetClickId = event && event.relatedTarget && event.relatedTarget.parentElement ? event.relatedTarget.parentElement.id : null;
                if (_parentTargetClickId && _parentTargetClickId.startsWith('sp_autocomplete_')) {
                    return true;
                }
                return false;
            }

            function getAddressFieldLabel(fieldName, options) {
                return AddressFormService.getAddressFieldLabel(fieldName, $rootScope.config.language.id, options);
            }

            function getAddressFormFieldSettings(fieldName) {
                return AddressFormService.getAddressFormFieldSettings(fieldName);
            }

            function _disableAllDropPinFields() {
                AddressFormService.disableAllDropPinFields(accountInfoCtrl.dropPinDisableFields);
            }

            function getDropPinClarifyMessage() {
                return AddressFormService.getDropPinClarifyMessage($rootScope.config.language.culture);
            }

            $scope.$on('checkout.details.setFormError', function (_, errorField) {
                var message = AddressFormService.getFormFieldErrorMessage(errorField);
                accountInfoCtrl.formErrorCtrl[errorField] = true;
                _setFormError(message);
            });

            $scope.$on('checkout.details.hideFormError', function (_, emitterData) {
                angular.forEach(emitterData.hiddenFields, function (field) {
                    accountInfoCtrl.formErrorCtrl[field] = false;
                });
                
                var _errorKey;
                if(accountInfoCtrl.formErrorCtrl.text1) { _errorKey = 'text1'; }
                else if(accountInfoCtrl.formErrorCtrl.city) { _errorKey = 'city'; }
                else if(accountInfoCtrl.formErrorCtrl.zipCode) { _errorKey = 'zipCode'; }

                if(_errorKey){
                    $scope.$emit('checkout.details.setFormError', _errorKey);
                    return;
                }

                _setFormError('');
            });
        }
    ]);
})(angular, app);
